import moment from 'moment';
import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';

// Actions & service & constants
import { loadAppointmentsByPractId, clearList } from '../reducer/actions';
import { localAppointmentsFilters } from '../../services/appointments';
import { getAppointmentViewState } from 'src/services/functions';
import { STATUS_CANCELLED, STATUS_REPLACED } from 'src/services/constants';

// Components
import PlanningHeader from '../components/PlanningHeader';
import Table from '../components/Table/Table';

const storeDateKey = 'planingDate';

function filterFromStatus(appointments) {
  if (appointments && Array.isArray(appointments)) {
    return appointments.filter((appointment) => {
      const appointStatus = getAppointmentViewState(appointment);
      return appointStatus !== STATUS_CANCELLED && appointStatus !== STATUS_REPLACED;
    });
  }
  return null;
}

class PlanningView extends Component {
  constructor() {
    super();
    this.state = {
      startDate: moment(localAppointmentsFilters.get(storeDateKey)) || moment(),
      filterList: null,
    };
    this.onDateChange = this.onDateChange.bind(this);
    this.loadAppointments = this.loadAppointments.bind(this);
  }

  componentDidMount() {
    this.loadAppointments();
  }

  componentDidUpdate(prevProps) {
    const { practitionerId, appointments: { list } } = this.props;
    // if change practitioner
    if (prevProps.practitionerId !== practitionerId) { this.loadAppointments(); }
    // if list changed
    if (prevProps && JSON.stringify(prevProps.appointments.list) !== JSON.stringify(list)) {
      this.filteringAppointmentList();
    }
  }

  componentWillUnmount() {
    this.props.clearList();
  }

  onDateChange(date) {
    localAppointmentsFilters.set({ [storeDateKey]: moment(date).format() });
    this.setState({ startDate: date }, () => {
      this.loadAppointments();
    });
  }

  loadAppointments() {
    const { loadAppointmentsByPractId, practitionerId } = this.props;
    const { startDate } = this.state;
    if (practitionerId) {
      loadAppointmentsByPractId(practitionerId, startDate);
    }
  }

  filteringAppointmentList() {
    const { appointments: { list } } = this.props;
    this.setState({ filterList: filterFromStatus(list) });
  }

  render() {
    const { startDate, filterList } = this.state;
    const { openVerifyModal } = this.props;

    return (
      <Fragment>
        <PlanningHeader startDate={startDate} onDateChange={this.onDateChange} />

        <Table openVerifyModal={openVerifyModal} appointmentsList={filterList} />
      </Fragment>
    );
  }
}

const mapStateToProps = (state) => ({
  appointments: state.practitioner.appointments,
  practitionerId: state.practitioner.common.commonFilters.practitionerId,
});

export default connect(
  mapStateToProps,
  {
    clearList,
    loadAppointmentsByPractId,
  },
)(PlanningView);
